import React from "react";
import { Schema } from "schemaComponents";
import { couponUrl } from "utils/coupon";

export default ({ isEditing }: { isEditing: boolean }): Schema => {
  return {
    schemaType: "object",
    properties: [
      {
        title: "投稿Id",
        propertyName: "mediaId",
        schema: {
          schemaType: "text",
          readOnly: true,
          required: true,
        },
      },
      {
        title: "投稿名",
        propertyName: "mediaName",
        schema: {
          schemaType: "text",
          readOnly: isEditing,
          required: true,
        },
      },
      {
        title: "最大取得ページ数",
        propertyName: "limit",
        schema: {
          schemaType: "number",
        },
      },
    ],
  };
};
